import React, {Component} from 'react'

// import styles
import './infomodal.scss'

// import components
import Modal from '../../components/Modal'

// Utils
import { translation } from '../../../utils/helpers'

class InfoModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false
    }
  }

  render () {
    return (
      <div className='info__modal'>
        <Modal {...this.props} header={translation('13420')} overflowHidden={this.state.overflowHidden}>
          {this.props.children}
        </Modal>
      </div>
    )
  }

}

export default InfoModal



// WEBPACK FOOTER //
// ./src/app/shared/modals/InfoModal/index.js